$(document).ready(function () {
  if ($(".blog-article-progress-bar").length) {
    var $blogArticleProgressBar = $(".blog-article-progress-bar");
    var $articleProgressContainer = $blogArticleProgressBar.find(".article-progress");

    var blogAPBWaypoint = new Waypoint.Sticky({
      element: $blogArticleProgressBar[0],
      stuckClass: 'fixed',
      offset: function () {
        return $(".navigation").height();
      }
    });

    $articleProgressContainer.css("width", getArticleProgress());

    $(window).scroll(function () {
      $articleProgressContainer.css("width", getArticleProgress());
    });

    $(window).resize(function () {
      $articleProgressContainer.css("width", getArticleProgress());
    });
  }
});

function getArticleProgress() {
  var progress = 100 - (($(window).scrollTop() / getArticleHeight()) * 100);
  progress = progress >=0 ? progress : 0;
  return progress + "%";
}

function getArticleHeight() {
  var pwHeight = $(".page-wrapper").height();
  var asHeight = $(".author-section").outerHeight();

  return pwHeight - asHeight;
}